module.exports = __webpack_public_path__ + "img/laptop.87117a08.png";